import { Endpoint } from "../../typings/endpoints";
import { Topic } from "../../typings/Topic";
import http from "../../utils/http";

const topicsApi = {
  getTopics: async (): Promise<Topic[]> => {
    const response = await http.get<Topic[]>(Endpoint.TopicList);
    return response.data;
  },
};

export default topicsApi;
